export default {
  privateSubtitle: '¿Desea enviar invitaciones para que respondan este formulario?',
  publicSubtitle: 'Comparta este enlace con quien desee que responda este formulario',
  cancel: 'Lo haré después',
  sendForm: 'Enviar formulario',
  shareLink: 'Enlace de compartir'
}
